module.exports = __webpack_public_path__ + "static/media/TN-Women-Sneakers.30735642.svg";